import { Subject } from "rxjs";
import { Utils } from "../../02_utils/utils";
import { Logger } from "../../02_utils/logger";
import { ScrollBarHelper } from "../../02_utils/scrollbarHelper";


export class BackdropHandler {

  public backdropActive: Subject<boolean> = new Subject();
  private scrollbarHelper: ScrollBarHelper = new ScrollBarHelper();

  constructor(private backdrop: HTMLElement, private $log: Logger, private $utils: Utils) {
    this.backdropActive.subscribe((active: boolean) => {
      if (active) {
        this.openBackdrop();
      } else {
        this.closeBackdrop();
      }
    });

    backdrop?.addEventListener('click', () => {
      this.backdropActive.next(false);
    });
  }

  private closeBackdrop() {
    this.backdrop?.setAttribute('data-active', 'false');
    this.scrollbarHelper.reset();
  }

  private openBackdrop() {
    this.backdrop?.setAttribute('data-active', 'true');
    this.scrollbarHelper.hide();
  }

}
